import React, { useState, useEffect } from "react"; 
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Select from "react-select";
import { Link } from "react-router-dom";
import { createEvent, getEvents ,fetchNotifications} from "../../../api/api"; 
import { useSocket } from "../../../core/context/SocketContext"; // adjust path
import { useTranslation } from "react-i18next";

const Calendar: React.FC = () => {
  const { t } = useTranslation();
  const { socket } = useSocket();

  const [startDate, setDate] = useState(new Date()),
    [showCategory, setshowCategory] = useState(false),
    [showmodel, setshowmodel] = useState(false),
    [showEvents, setshowEvents] = useState(false),
    [show, setshow] = useState(false),
    [iseditdelete, setiseditdelete] = useState(false),
    [addneweventobj, setaddneweventobj] = useState<any>(null),
    [isnewevent, setisnewevent] = useState(false),
    [event_title, setevent_title] = useState(""),
    [eventDate, setEventDate] = useState(""),
    // save event time
    [eventTime, setEventTime] = useState(""),
    [category_color, setcategory_color] = useState(""),
    [calenderevent, setcalenderevent] = useState<any>(null),
    [weekendsVisible, setweekendsVisible] = useState(true),
    [currentEvents, setscurrentEvents] = useState<any[]>([]);

  // category → color mapping
  const categoryColorMap: Record<string, string> = {
    Meeting : "bg-info",
    Event: "bg-success",
    "Payment Reminder": "bg-danger",
    "Task Reminder": "bg-warning",
  };

  useEffect(() => {
    // add width-100 class to datepicker wrapper
    let elements = Array.from(
      document.getElementsByClassName("react-datepicker-wrapper")
    );
    elements.map((element) => element.classList.add("width-100"));

    // fetch events from backend
    const fetchEvents = async () => {
      try {
        const eventsFromApi = await getEvents();
        console.log("Events from API:", eventsFromApi); // 🔍 check actual keys

        const formattedEvents = eventsFromApi.map((event: any) => ({
          id: event.event_id,
           title: event.event_title || "Untitled Event", // ✅ use correct field
          start: event.event_date,
          className: categoryColorMap[event.event_category] || "bg-primary",
        }));
        setscurrentEvents(formattedEvents);
      } catch (err) {
        console.error("Failed to fetch events:", err);
      }
    };
    
    fetchEvents();
  }, []);

  //notifications
  useEffect(() => {
  const loadNotifications = async () => {
    try {
      const data = await fetchNotifications();
      console.log("Notifications:", data);

      //  Example: you can display them, or trigger alerts
      data.forEach((notification: any) => {
      console.log(" New Notification:", notification.event_title);
      });

    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    }
  };

  loadNotifications();
}, []);

  //web socket useEffect
  useEffect(() => {
  if (!socket) return;

  // Listen for reminder notifications from backend
  socket.on("reminderNotification", (data: any) => {
    // show alert or update state
    alert(`Reminder: ${data.message}`);

    // optionally, add the reminder to your calendar events
    if (data.event) {
      setscurrentEvents((prev) => [
        ...prev,
        {
          id: data.event.event_id,
          title: data.event.event_title,
          start: data.event.event_date,
          className:
            categoryColorMap[data.event.event_category] || "bg-primary",
        },
      ]);
    }
  });

  // cleanup listener on unmount
  return () => {
    socket.off("reminderNotification");
  };
}, [socket]);


  // submit new event to backend
  const handleCreateEvent = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!eventDate || !eventTime || !event_title || !category_color) {
      alert("Please fill all required fields");
      return;
    }

    const now = new Date();
    const eventDateTime = getEventDateTime(eventDate, eventTime);
    const userEmail = localStorage.getItem("email") || "Unknown User";


    const newEvent = {
      event_id: Date.now().toString(),
      event_date: eventDateTime,
      event_category: category_color,
      event_title,
      user_name: userEmail,
      created_date: formatDateTime(now),
       is_notified: 1, // <-- add this here
    };

    try {
      await createEvent(newEvent);
      alert("Event created successfully");
      

      // add to calendar
      setscurrentEvents((prev) => [
        ...prev,
        {
          id: newEvent.event_id,
          title: newEvent.event_title,
          start: newEvent.event_date,
          className: categoryColorMap[newEvent.event_category] || "bg-primary",
        },
      ]);

      //Emit WebSocket notification so Header can update
    if (socket) {
      socket.emit("reminderNotification", {
        message: `New Reminder: ${newEvent.event_title}`,
        event: newEvent,
      });
    }

      // reset form
      setevent_title("");
      setEventDate("");
      setEventTime("");
      setcategory_color("");
      handleClose();

      // manually close Bootstrap modal
      const modalElement = document.getElementById("add_event");
      if (modalElement) {
        modalElement.classList.remove("show");
        modalElement.style.display = "none";
        document.body.classList.remove("modal-open");
        const modalBackdrop = document.querySelector(".modal-backdrop");
        if (modalBackdrop) modalBackdrop.remove();
      }
    } catch (error) {
      console.error("Error creating event:", error);
      alert("Failed to create event");
    }
  };


  const handleClose = () => {
    setisnewevent(false);
    setiseditdelete(false);
    setshow(false);
    setshowCategory(false);
    setshowEvents(false);
    setshowmodel(false);
  };

  const handleEventClick = (clickInfo: any) => {
    setiseditdelete(false);
    setevent_title(clickInfo.event.title);
    setcalenderevent(clickInfo.event);
  };

  const handleDateSelect = (selectInfo: any) => {
    setisnewevent(true);
    setaddneweventobj(selectInfo);
  };

  const onupdateModalClose = () => {
    setiseditdelete(false);
    setevent_title("");
  };

  const handleClick = () => setshow(true);

  // format Date object as MySQL DATETIME string
  function formatDateTime(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, "0");
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      " " +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds())
    );
  }

  // combine selected date with current local time
  function getEventDateTime(dateString: string, timeString: string): string {
  const [hours, minutes] = timeString.split(":").map(Number);

  const date = new Date(dateString);
  date.setHours(hours, minutes, 0);

  return formatDateTime(date);
}

  

  

  const options1 = [
    { value: "Meeting", label: "Meeting" },
    { value: "Event", label: "Event" },
    { value: "Payment Reminder", label: "Payment Reminder" },
    { value: "Task Reminder", label: "Task Reminder" },
  ];

  const defaultValue = options1[0];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row align-items-center w-100">
              <div className="col-lg-10 col-sm-12">
                <h3 className="page-title">{t("Calendar")}</h3>
              </div>
              <div className="col-lg-2 col-sm-12 d-flex justify-content-end p-0">
                <Link
                  to="#"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#add_event"
                >
                  {t("Create Reminder")}
                </Link>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-4">
              {/* <h4 className="card-title">Drag &amp; Drop Event</h4> */}
              <div id="calendar-events" className="mb-3">
                <div className="calendar-events" data-class="bg-info">
                  <i className="fas fa-circle text-info" />  {t("Meeting")}
                </div>
                <div className="calendar-events" data-class="bg-success">
                  <i className="fas fa-circle text-success" /> {t("Event")}
                </div>
                <div className="calendar-events" data-class="bg-danger">
                  <i className="fas fa-circle text-danger" /> {t("Payment Reminder")}
                </div>
                <div className="calendar-events" data-class="bg-warning">
                  <i className="fas fa-circle text-warning" /> {t("Task Reminder")}
                </div>
              </div>
            </div>

            <div className="col-lg-9 col-md-8">
              <div className="card bg-white">
                <div className="card-body">
                <>
                      <style>
                        {`
                          /* Event hover styling */
                          .fc-event {
                            transition: all 0.2s ease;
                            cursor: pointer;
                          }
                          .fc-event:hover {
                            background-color: #00796b !important;
                            border-color: #004d40 !important;
                            color: #fff !important;
                            transform: scale(1.05);
                            z-index: 9999;
                          }

                          /* Highlight all events in a day column on hover */
                          .fc-daygrid-day:hover .fc-event {
                            background-color: #00796b !important;
                            border-color: #004d40 !important;
                            color: #fff !important;
                          }

                          /* Highlight day cell */
                          .fc-daygrid-day:hover {
                            background-color: #b2dfdb;
                          }

                          /* Tooltip for long event names */
                          .event-tooltip {
                            position: absolute;
                            background: #00796b;
                            color: #fff;
                            padding: 5px 10px;
                            border-radius: 5px;
                            white-space: nowrap;
                            pointer-events: none;
                            z-index: 99999;
                            font-size: 12px;
                            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
                          }

                          /* Scrollable calendar container */
                          .calendar-wrapper {
                            height: 75vh;        /* fixed height */
                            overflow-y: auto;    /* vertical scroll */
                            overflow-x: auto;    /* horizontal scroll */
                          }

                          /* Prevent FullCalendar from shrinking columns */
                          .fc-col-header, .fc-daygrid-body {
                            min-width: 700px;    /* adjust as needed */
                          }
                        `}
                      </style>

                      <div className="calendar-wrapper">
                        <FullCalendar
                          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                          headerToolbar={{
                            left: "prev,next today",
                            center: "title",
                            right: "dayGridMonth,timeGridWeek,timeGridDay",
                          }}
                          initialView="dayGridMonth"
                          editable={true}
                          selectable={true}
                          selectMirror={true}
                          dayMaxEvents={true}
                          weekends={weekendsVisible}
                          events={currentEvents}
                          select={handleDateSelect}
                          eventClick={handleEventClick}
                          nowIndicator={true}
                          height="auto"

                          eventDidMount={(info) => {
                            const tooltip = document.createElement("div");
                            tooltip.className = "event-tooltip";
                            tooltip.innerText = info.event.title;
                            tooltip.style.display = "none";
                            document.body.appendChild(tooltip);

                            info.el.addEventListener("mouseenter", (e) => {
                              const target = e.target as HTMLElement | null;
                              if (!target) return;

                              tooltip.style.display = "block";
                              const rect = target.getBoundingClientRect();
                              tooltip.style.top = rect.top - tooltip.offsetHeight - 5 + "px";
                              tooltip.style.left = rect.left + "px";
                            });

                            info.el.addEventListener("mousemove", (e) => {
                              const target = e.target as HTMLElement | null;
                              if (!target) return;

                              const rect = target.getBoundingClientRect();
                              tooltip.style.top = rect.top - tooltip.offsetHeight - 5 + "px";
                              tooltip.style.left = rect.left + "px";
                            });

                            info.el.addEventListener("mouseleave", () => {
                              tooltip.style.display = "none";
                            });
                          }}
                        />
                      </div>
                    </>



                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Event Modal */}
      <div id="add_event" className="modal custom-modal fade" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t("Add Event")}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">x</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleCreateEvent}>
                <div className="form-group">
                  <label>
                   {t("Event Name")} <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={event_title}
                    onChange={(e) => setevent_title(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>
                    {t("Event Date")} <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    <input
                      className="form-control"
                      type="date"
                      value={eventDate}
                      onChange={(e) => setEventDate(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                <label>
                  {t("Event Time")} <span className="text-danger">*</span>
                </label>
                <div className="cal-icon">
                  <input
                    className="form-control"
                    type="time"
                    value={eventTime}
                    onChange={(e) => setEventTime(e.target.value)}
                    required
                  />
                </div>
              </div>
                <div className="form-group mb-3">
                  <label>{t("Category")}</label>
                  <Select
                    options={options1}
                    value={
                      category_color
                        ? { value: category_color, label: category_color }
                        : null
                    }
                    onChange={(selected: any) =>
                      setcategory_color(selected.value)
                    }
                  />
                </div>
                <div className="submit-section">
                  <button type="submit" className="btn btn-primary submit-btn">
                    {t("Submit")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Event Modal */}


    {/* Add Event Modal (other) */}
      <div className="modal custom-modal fade none-border" id="my_event">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Add Event")}</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              ></button>
            </div>
            <div className="modal-body" />
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-success save-event submit-btn"
              >
                {t("Create event")}
              </button>
              <button
                type="button"
                className="btn btn-danger delete-event submit-btn"
                data-dismiss="modal"
              >
                 {t("Delete")}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Event Modal */}

      {/* Add Category Modal */}
      <div className="modal custom-modal fade" id="add_new_event">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Add Category")}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-hidden="true"
              >
                <span aria-hidden="true">x</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">{t("Category Name")}</label>
                  <input
                    className="form-control form-white"
                    placeholder={t("Enter name")}
                    type="text"
                    name="category-name"
                  />
                </div>
                <div className="form-group mb-0 mt-3">
                  <label className="col-form-label">{t("Choose Category Color")}</label>
                  <Select
                    className="form-white"
                    defaultValue={defaultValue}
                    options={options1}
                    placeholder={t("Success")}
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="submit-section">
                  <button
                    type="button"
                    className="btn btn-primary save-category submit-btn"
                    data-dismiss="modal"
                  >
                    {t("Save")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Category Modal */}
    </>
  );
};

export default Calendar;